export enum ValidationState {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
  Valid = 'valid',
}
type ValidationFunction = (...args: any[]) => { state: ValidationState; message?: string };

const validationFunctionStub = () => ({ state: ValidationState.Valid });

/**
 * TODO:
 * This is going to change in the following ways:
 * 1. A validation function will be called so that `.validate()` can be called
 *    on the instance
 * 2. `hasError` will be replaced with `state`/`isValid` for flexibility
 *
 */
export class SendNodeValidation {
  // NOTE: `hasError` will be deprecated in favor of `state`/`isValid`
  hasError = false;
  message = '';
  isValid = true;
  state: ValidationState = ValidationState.Valid;
  private validationFunction: ValidationFunction = validationFunctionStub;
  constructor(showMessage: boolean, message = '', type = ValidationState.Error) {
    const isErrorValidation = type === ValidationState.Error;
    this.hasError = isErrorValidation ? showMessage : false;
    this.message = showMessage ? message : '';
  }
}
